/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgReCenter = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 15h2v5h5v2H2zm20 0h-2v5h-5v2h7zM9 2v2H4v5H2V2zm6 0v2h5v5h2V2zm0 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgReCenter as ReCenter };
